//接口请求域名
const API_URL = "https://new.gutingjun.com/";

//会议列表
export const meetingList =  API_URL + 'api/member/meeting/list';
export const lectorList =  API_URL + 'api/member/lector/list';
export const meetDetail =  API_URL + 'api/member/meeting/detail';
export const applyOne =  API_URL + 'api/member/meeting/apply_0';
export const safeCodeUrl =  API_URL + 'api/member/meeting/message';
export const enterApply =  API_URL + 'api/member/meeting/enter1';
export const redirectUri =  API_URL + 'api/member/wxpay/bridge/redirect_uri';
export const authorize =  API_URL + 'api/member/wxpay/bridge/authorize';
export const ifpay =  API_URL + 'api/member/meeting/order/confirm';
export const contacttypelist =  API_URL + 'api/owner/autonomous/list/ContactTypeEnum';



// WEBPACK FOOTER //
// ./src/service/Api.js